import React from 'react';
import styled from 'styled-components';
import { assertCondition } from '../../utils/types';
import SvgIcon from './SvgIcon';
import IconWrapper from './IconWrapper';
import { IconName } from './types';
import { theme } from '../../styles/theme';

/**
 * Use this component when you need an SVG icon with following number
 */

interface IProps {
  name: IconName;
  positiveIndex: number;
  isActive: boolean;
}

const IconIndex = styled.span<{ $isSingleDigit: boolean }>`
  position: absolute;
  right: ${({ $isSingleDigit }) => ($isSingleDigit ? -4 : -8)}px;
  bottom: 7px;
  display: inline-block;
  font-size: 12px;
  font-weight: 600;
  line-height: 0;
  color: ${theme.colors.mainBlue};
`;

const IndexedIcon = ({ name, positiveIndex, isActive }: IProps) => {
  assertCondition(positiveIndex > 0);

  return (
    <IconWrapper>
      <SvgIcon name={name} width={16} height={16} isActive={isActive} />
      <IconIndex $isSingleDigit={positiveIndex < 10}>{positiveIndex}</IconIndex>
    </IconWrapper>
  );
};

export default IndexedIcon;
